export default "__VITE_ASSET__BBZiLM80__"